<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <navBar :tags="tags" :title="title" :subTitle="subTitle" :btnSave="false" :btnBack="true"
                @btnBackClick="handleBackClick"
        />
        <section :class="$style.body">

            <el-row style="padding-top: 20px">
                <el-col :span="8">
                    <div align="left">
                        <el-button-group :class="$style.month" class="a_modal">
                            <el-button size="small" icon="el-icon-arrow-left"
                                       @click.stop="lastNextMonthClick(-1)"></el-button>
                            <el-button size="small" disabled>{{dateStr}}</el-button>
                            <el-button size="small" icon="el-icon-arrow-right"
                                       @click.stop="lastNextMonthClick(1)"></el-button>
                        </el-button-group>
                    </div>
                </el-col>

                <el-col :span="8">
                    <div align="center">
                        <span style="font-size: 28px;color: #646464">{{dateStr}}</span>
                    </div>
                </el-col>

                <el-col :span="8">
                    <div align="right">
                        <el-form ref="form" :model="form" :inline="true">
                            <el-form-item label="店员" prop="area">
                                <el-select v-model="clerk" v-on:change="handleClerkClick" clearable
                                           placeholder="所有店员" size="small" style="width: 160px">
                                    <el-option v-for="item in clerkData" :key="item.user_id"
                                               :label="item.clerk_name"
                                               :value="item.user_id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>

                    </div>
                </el-col>

            </el-row>

            <div :class="$style.bottom">
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%" :class="$style.table"
                        :default-sort="{prop: 'startTime', order: 'descending'}">
                    <el-table-column
                            type="index"
                            label="序号"
                            width="60px"
                    >
                    </el-table-column>
                    <el-table-column
                            property="start_date"
                            label="原班次"
                            sortable
                            width="170"
                    >
                        <template slot-scope="scope">
                            <span>{{scope.row.original_date}}</span>
                            <span :class="$style.span_shift" :style="{'background':getBackground(scope.row.original_icon_color)}">{{scope.row.original_icon_text ? scope.row.original_icon_text : '未排班'}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            property="end_date"
                            label="新班次"
                            sortable
                            width="170">
                        <template slot-scope="scope">
                            <span>{{scope.row.change_to_date}}</span>

                            <span :class="$style.span_shift" :style="{'background':getBackground(scope.row.change_icon_color)}">{{scope.row.change_icon_text ? scope.row.change_icon_text : '未排班'}}</span>

                        </template>
                    </el-table-column>
                    <el-table-column
                            property="reason"
                            label="事由"
                            sortable
                    >
                    </el-table-column>
                    <el-table-column
                            property="last_name"
                            label="申请人"
                            sortable
                            width="90"
                    >
                    </el-table-column>
                    <el-table-column
                            property="status"
                            label="状态"
                            sortable
                            width="90">
                        <template slot-scope="scope">
                            <span>{{getStatus(scope.row.status)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right" label="操作"
                            width="80">
                        <template slot-scope="scope">
                            <el-button
                                    type="warning" size="small"
                                    @click="handleDetail(scope.$index, scope.row)">查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--<pagination :page="page" @changePage="changePageClick"></pagination>-->
                <div class="channel" align="center">
                    <section style="margin-top: 5px" class="ware">
                        <div v-for="(item, index) in shiftArray" :key="index" :label="item" :span="8">
                            <div style="padding: 5px" v-if="item.shift_id">
                                <span :class="$style.span_shift" :style="{'background':getBackground(item.icon_color)}">{{item.icon_text}}</span>
                                <section style="margin-top: 5px">
                                    <span>{{item.start_time}}-{{item.end_time}}</span>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

        </section>
    </div>
</template>
<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import moment from 'moment'

    export default {
        data() {
            return {
                loading: false,
                tags: ['考勤', '门店详情'],
                title: '门店',
                subTitle: '调班申请',
                id:'',
                clerk: '',
                clerkData: [],
                tableData: [],
                shiftArray: [],
                date: {},
                dateStr: "",
            }
        },
        components: {
            navBar
        },
        computed: {
            isDisabled() {
                if (this.message) {
                    return false
                }
                return true
            }
        },
        created() {

            let obj = this.$store.getters.getStore
            this.id = obj.id
            this.title = obj.storeName
            this.shiftArray = obj.shiftArray

            if(obj.dateOne){
                this.date = obj.dateOne
            }else {
                this.date = moment()
            }
            this.dateStr = this.getCurrentDate()

            this.getOtRecords()

        },
        methods: {

            getCurrentDate() {

                let date = moment(this.date)
                return date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'

            },
            lastNextMonthClick(num) {

                let currentDate = moment(this.date)
                let date = currentDate.add(num, "months")
                this.date = date
                this.dateStr = date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'

                this.getOtRecords()
            },
            getFormatDate(arg) {

                if (!arg) {
                    return '';
                }
                var re = arg + '';
                if (re.length < 2) {
                    re = '0' + re;
                }
                return re;
            },
            async getOtRecords(){
                this.loading = true

                try {

                    let data = {
                        // limit: this.page.size,
                        // offset: this.page.current - 1,
                        store_id: this.id,
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        type: 'CHANGE',
                        createby: this.clerk,
                        month: this.date.format("YYYY-MM")
                    }
                    this.tableData = []

                    await http.post('/wapi/v1/getApprovalList', data).then(res => {

                        // this.page.total = res.data.total

                        this.tableData = res.data.array_list
                        this.clerkData = res.data.clerk_list
                        this.shiftArray = res.data.shiftBArray

                        this.loading = false

                        this.$store.commit('setStore', {
                            id: this.id,
                            dateOne:this.date,
                            storeName: this.title,
                            shiftArray:this.shiftArray
                        })
                    })

                } catch (err) {
                    this.loading = false
                    console.log(`error:${err}`)
                }
            },
            // 点击详情
            handleDetail(index, row) {
                // this.$store.commit('setStore', {
                //     id: row.store_id,
                //     storeName: row.name
                // })
                this.$router.push({
                    path: '/attendance/shiftInfo',
                    query: {
                        row: row
                    }
                })

            },
            handleClerkClick() {//选择店员
                this.getOtRecords()
            },
            getStatus(status){

                switch (status){
                    case 'AWAIT':
                        return '待审批'
                    case 'APPROVE':
                        return '已批准'
                    case 'REFUSE':
                        return '已拒绝'
                }

            },
            // 修改班次的背景色
            getBackground(color) {
                if(color){
                    return 'rgb(' + color + ')'
                }else {
                    return 'rgb(155,155,155)'
                }
            },
            // 返回按钮
            handleBackClick() {
                this.$router.push({
                    path: '/attendance'
                })
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';

    .container {
        background: #fff;
        padding: 20px 20px;
        height: 100%;
        box-sizing: border-box;
        .body {

            .title {
                font-size: $fontSize;
                line-height: $fontSize;
                em {
                    display: inline-block;
                    margin-right: 50px;
                    color: #000000;
                }
                span {
                    display: inline-block;
                    color: #4a90e2;
                    margin-right: 30px;
                }
            }
            .month {
                margin-bottom: 15px;
            }
            .text {
                font-size: 14px;
                color: #4D586D;
            }
            .bottom {

                .table {
                    margin-top: 15px;
                }
                .pagination {
                    margin-top: 50px;
                    text-align: center;
                }
                .span_shift {
                    font-size: 12px;
                    color: #FFFFFF;
                    border-radius: 3px;
                    padding: 4px;
                    display: -moz-inline-box;
                    display: inline-block;
                    text-align: center;
                    line-height: 15px;
                    width: 40px;
                }
            }
        }
    }
</style>
<style scoped>

    .a_modal >>> .el-button {
        color: #646464;
    }
    .channel {
        margin-top: 20px;
        font-size: 12px;
        color: #808080;
        vertical-align: middle;
    }
    .ware {
        display: flex;
        justify-content: center;
    }


</style>




// WEBPACK FOOTER //
// src/pages/attendance/shiftApply/index.vue